import { DatasourceFacade } from '@mode/accounts/domain';
import { DatasourceDomain } from '@mode/shared/contract-common';
import { MixableBaseController } from '~/common/component';
import { takeUntil } from 'rxjs/operators';
import template from './create-definition-modal.html';

export default class CreateDefinitionModalController extends MixableBaseController {
  definition: any;
  name: string;
  datasourcePickerOpen = false;

  datasources: ReadonlyArray<DatasourceDomain.Datasource>;
  datasource: DatasourceDomain.Datasource;

  workspaceTitle = 'Workspace';
  current: any; // JSON of current data
  account: any; // AccountModel
  rename: boolean;

  onCancel: () => void;
  onConfirm: (args: { $definition: any }) => void;

  static $inject = ['LibraryDefinitionModel', 'DatasourceFacade'];

  constructor(
    private LibraryDefinitionModel,
    private datasourceFacade: DatasourceFacade
  ) {
    super();
    this.definition = new LibraryDefinitionModel.model();
  }

  $onInit() {
    if (this.current) {
      this.definition.name = this.current.name;
      this.definition.description = this.current.description;
    }

    const datasources$ = this.account.user ? this.datasourceFacade.datasources$ : this.datasourceFacade.orgDatasources$;
    const datasource$ = this.account.user
      ? this.datasourceFacade.defaultDatasource$
      : this.datasourceFacade.defaultOrgDatasource$;

    datasources$.pipe(takeUntil(this.destroyed$)).subscribe((datasources) => (this.datasources = datasources));
    datasource$.pipe(takeUntil(this.destroyed$)).subscribe((datasource) => {
      this.datasource = datasource;
      this.definition.dataSourceId = datasource.id;
    });
  }

  createDefinition() {
    this.onConfirm({ $definition: this.definition });
  }

  cancel() {
    this.onCancel();
  }

  toggleDatasourcePicker($event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.datasourcePickerOpen = !this.datasourcePickerOpen;
  }

  closeDatasourcePicker() {
    this.datasourcePickerOpen = false;
  }

  selectDatasource(source: DatasourceDomain.Datasource) {
    this.datasource = source;
    this.current.dataSourceId = this.datasource.id;
    this.definition.dataSourceId = this.datasource.id;
    this.closeDatasourcePicker();
  }
}

export const CreateDefinitionModalComponent: angular.IComponentOptions = {
  controller: CreateDefinitionModalController,
  controllerAs: 'ctrl',
  template,
  bindings: {
    account: '<',
    current: '<',
    title: '<',
    onCancel: '&',
    onConfirm: '&',
    rename: '@?',
  },
};
